<template>
  <div class="help-slides">

    <swiper
        :slides-per-view="1"
        :space-between="30"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
    >
      <swiper-slide
          v-for="n in getSlidesAmount()"
          :key="n"
          class="test"
          :class="{test_2: true}"
      >
        <img
            :src="getImageUrl(n)"
            class="img-fluid h-100 mx-auto"
            blank="true"
        >
      </swiper-slide>
    </swiper>
    <div class="info-wrapper">
      <div class="skip" @click="skip">{{ $t('faqSlides.skip') }}</div>
      <div class="slide-texts">
        <div class="slide-title">{{ getSlideTitle() }}</div>
        <div class="slide-description">{{ getSlideDescription() }}</div>
      </div>
      <div class="slider-actions">
        <div class="slider-pagination">
          <div class="slider-action" v-for="n in getSlidesAmount()" :key="n"
               :class="{active: currentSlide === n}"></div>
        </div>
        <div class="next-button">
          <div v-if="currentSlide != getSlidesAmount()" @click="nextSlide"><img src="@/assets/img/icons/Vector.svg"
                                                                                alt=""></div>
          <div v-else @click="nextSlide">{{ $t('faqSlides.getStarted') }} <img src="@/assets/img/icons/Vector.svg"
                                                                               alt=""></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {Navigation, Pagination} from 'swiper'

import {SwiperCore, Swiper, SwiperSlide} from 'swiper-vue2'

// Import Swiper styles
import 'swiper/swiper-bundle.css'

SwiperCore.use([Navigation, Pagination])

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      currentSlide: 1,
      swiper: null
    }
  },
  emits: ['close'],
  methods: {
    getImageUrl(imageId) {
      return require('@/assets/img/faq-slides/' + this.getLocaleType() + '/' + imageId + '.png');
    },
    onSwiper(swiper) {
      this.swiper = swiper
    },
    onSlideChange(a) {
      this.currentSlide = a.snapIndex + 1
    },
    getLocaleType() {
      return this.$store.getters.getStoreMode
    },
    getSlideTitle() {
      var path = 'faqSlides.' + this.getLocaleType() + '.' + this.currentSlide + '.title'
      return this.$t(path)
    },
    getSlideDescription() {
      var path = 'faqSlides.' + this.getLocaleType() + '.' + this.currentSlide + '.description'
      return this.$t(path)
    },
    skip() {
      this.$emit('close')
    },
    nextSlide() {
      if (this.currentSlide === this.getSlidesAmount()) {
        this.$emit('close')
      } else {
        this.swiper.slideNext()
      }
    },
    getSlidesAmount() {
      if (this.getLocaleType() === 'menu') {
        return 4
      }
      return 5
    }
  }
}
</script>

<style scoped lang="scss">

.help-slides {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: white;
  height: -webkit-fill-available;
  min-height: 100dvh;
  width: 100vw;
}

.img-fluid {
  max-width: 100%;
  height: 100%;
  width: auto;
  display: block;
}

.w-100 {
  width: 100%;
}

.ml-auto, .mx-auto {
  margin-left: auto;
}

.mr-auto, .mx-auto {
  margin-right: auto;
}

.skip {
  position: absolute;
  color: #971DDE;
  top: 7dvh;
  z-index: 10000;
  right: 10%;
  text-decoration: underline;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
}

.slide-texts {
  position: absolute;
  z-index: 10000;
  padding: 0 6%;
  top: 70%;
}

.slide-title {
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  text-align: left;
  color: #120068;
  margin-bottom: 10px;
}

.slide-description {
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  color: black;
}

.slider-actions {
  position: absolute;
  top: 85%;
  width: 100%;
  display: flex;
  z-index: 10000;
}

.next-button {
  border-radius: 100px;
  background-color: #971DDE;
  height: 60px;
  min-width: 60px;
  right: 10%;
  position: absolute;
  padding: 0 19px;
}

.next-button div {
  height: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  color: white;
  font-size: 16px;
  font-weight: 590;
  line-height: 24px;
  gap: 12px;
}

.next-button img {
  width: 22px;
  height: 22px;
  margin: auto;
  display: flex;
}

.slider-pagination {
  display: flex;
  gap: 10px;
  position: absolute;
  left: 6%;
  height: 60px;
  align-items: center;
}

.slider-action {
  width: 20px;
  height: 6px;
  border-radius: 8px;
  background-color: #D9D9D9;
  transition: 0.3s;
}

.slider-action.active {
  background-color: #DABFE9;
  width: 40px;
}

.swiper-container {
  //height: 100%;
}

.info-wrapper {
  max-width: 768px;
}

.swiper-slide {
  //width: auto !important;
}

.swiper-container {
  height: 100%;
}
</style>
